import { articles } from '@/mocks/data';
import { Link } from 'react-router-dom';

export default function LatestContent() {
  const latestArticles = [...articles].sort((a, b) => {
    return new Date(b.date).getTime() - new Date(a.date).getTime();
  }).slice(0, 6);

  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
            最新上线
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            持续更新优质内容，不错过每一个精彩瞬间
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {latestArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className={`group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-300 cursor-pointer ${
                index === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${index === 0 ? 'h-64 lg:h-full' : 'h-48'}`}>
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                {index === 0 && (
                  <div className="absolute bottom-4 left-4 right-4">
                    <span className="px-2.5 py-1 bg-accent-500 text-background-50 text-xs rounded-full font-medium whitespace-nowrap mb-2 inline-block">
                      {article.categoryName}
                    </span>
                    <h3 className="font-heading text-lg font-bold text-background-50 line-clamp-2 group-hover:text-primary-300 transition-colors">
                      {article.title}
                    </h3>
                  </div>
                )}
              </div>
              {index > 0 && (
                <div className="p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-full font-medium whitespace-nowrap">
                      {article.categoryName}
                    </span>
                  </div>
                  <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h3>
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span>{article.date}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {article.views.toLocaleString()}
                    </span>
                  </div>
                </div>
              )}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}